import {
  ANDRUM_SUPABASE_PROJECT,
  createBrowserClient,
  type AndrumSupabaseClient,
} from "@andrum/database";

let client: AndrumSupabaseClient | null = null;

function readPublicConfig() {
  const url =
    import.meta.env.VITE_SUPABASE_URL ?? ANDRUM_SUPABASE_PROJECT.url;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? "";

  return { url, anonKey };
}

/**
 * Lazy singleton. Returns null when anon key is not configured yet
 * so the app can keep running in offline/mock (demo) mode.
 */
export function getSupabase(): AndrumSupabaseClient | null {
  const { url, anonKey } = readPublicConfig();
  if (!anonKey) {
    return null;
  }

  if (!client) {
    client = createBrowserClient({ url, anonKey });
  }
  return client;
}

export function isSupabaseConfigured(): boolean {
  return Boolean(import.meta.env.VITE_SUPABASE_ANON_KEY);
}

/** When Supabase is configured, auth is required for protected routes. */
export function isAuthEnforced(): boolean {
  return isSupabaseConfigured();
}

export { ANDRUM_SUPABASE_PROJECT };
